export enum KioskCookies {
    SavedSession = 'Saved_Session'
}
